<template>
  <div class="form-module">
    <p class="module-title">{{ $locale("rules.formDispClassificationSetting") }}</p>
    <el-form-item :label="$locale('rules.formDispClassification_entertainment') + ' *'" class="w387">
      <el-select v-model="form.boxOfficeType">
        <el-option
          v-for="item in options"
          :label="item.label"
          :value="item.value"
          :key="item.value"
        ></el-option>
      </el-select>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: "ruleTemplateBoxOfficeModule",
  data() {
    return {
      form: {
        boxOfficeType: "",
      },
      options: [
        {
          label: this.$locale("movie.mainBusiness"),
          value: "boxOffice",
        },
        {
          label: this.$locale("movie.morningShow"),
          value: "morningShow",
        },
        {
          label: this.$locale("movie.lateShow"),
          value: "lateShow",
        },
        {
          label: this.$locale("movie.allNight"),
          value: "allNight",
        },
        {
          label: this.$locale("movie.specialBusiness"),
          value: "special",
        }
      ],
    };
  },
  props: {
    formObj: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    formObj() {
      this.form = { boxOfficeType: this.formObj.ticketRule.boxOfficeType };
    },
  },
};
</script>
